export default __webpack_public_path__ + "_/shared_modules/base-layout/img/waiting-b0dc4efcc9091b04fe8689617c97c5fc.svg";